import React from "react";

const Stat_Standard_Normal_Distrib = () => {
  return (
    <div>
      <h1>Stat Standard Normal Distrib.</h1>
    </div>
  );
};

export default Stat_Standard_Normal_Distrib;
